/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { DateFormatOptions } from "./DateFormatOptions";
import { defaultLocale, defaultTimezone } from "./constants";

/**
 * Converts given UTC dates times to local times interval string using the provided options.
 * @example "08:00AM-05:30PM" (for eight o'clock in the morning to five thirty in the afternoon using "en-US" locale).
 * @param startDateTime The start date-time to convert.
 * @param endDateTime The end date-time to convert.
 * @param options The options for formatting the date.
 * @returns The formatted local times intervals string.
 */
export const toLocalTimesInterval = (startDateTime: Date, endDateTime: Date, options: DateFormatOptions): string => {
    const { locale, timeZone } = options;

    // TODO: Use 'Intl.DateTimeFormat().formatRange(startTime, endTime)' after upgrading TypeScript.
    const startTime = Intl.DateTimeFormat(locale ? locale : defaultLocale, {
        hour: "2-digit",
        minute: "2-digit",
        timeZone: timeZone ? timeZone : defaultTimezone
    }).format(startDateTime);

    const endTime = Intl.DateTimeFormat(locale ? locale : defaultLocale, {
        hour: "2-digit",
        minute: "2-digit",
        timeZone: timeZone ? timeZone : defaultTimezone
    }).format(endDateTime);

    return `${startTime}-${endTime}`;
};
